import React from 'react'
import image from '../../assets/img/9419-loading-circles.gif'
const LoadingApp = () => {
    return (
        <figure className='loading_app'>
            <img src={image} alt='Loading...' />
        </figure>
    )
}

export default LoadingApp
